import React, { useEffect } from 'react';
import { PanelHeader, Heading, ThemeButton } from "static/styled/custom.styled";
import { SeriesEditorMainContainer } from "./SeriesEditor.styled";
import { module as story } from "@st/story";
import { connectStore } from "redux-box";
import { ActivityModalContainer } from "static/styled/ActivityModal.styled";
import { SelectionLabels, SelectTagsListContainer, TagLabelContainer } from "@c/activity-view/activity-creator/tag-editor/TagEditor.styled";
import InfiniteScroll from "react-infinite-scroller";

import {
  InfiniteScrollParentContainer,
  InfiniteScrollLoader,
} from "static/styled/custom.styled";
import swal from 'sweetalert2';

const SeriesEditor = ({ story }) => {

  const { series_result, active_story, series_list = [], story_series, fetch_series } = story

  useEffect(() => {
    story.requestGetAllSeries();
  }, [])

  const handleSeriesTag = (seriesId) => {
    let data = {
      story: active_story.id,
      series_id: seriesId,
      // order: story_series.length + 1
    }
    if (story_series.length < 1) {
      story.requestMapSeriesToStory(data);
    } else {
      swal({
        title: 'Oops!',
        message: 'You can add 1 series to a story.',
        type: 'warning',
      })
    }
  }

  const fetchMoreSeries = () => {
    if (
      series_result !== null &&
      series_result.has_next
    ) {
      setTimeout(() => {
        if (
          series_result !== null &&
          series_result.next_page > 0
        )
          story.requestSeriesListConcat(
            series_result.next_page
          );
      }, 100);
    }
  };

  return (
    <SeriesEditorMainContainer>
      <PanelHeader primary>
        <Heading style={{ margin: "0px" }}> Assign Series </Heading>
        <ThemeButton primary onClick={() => story.setStoryEditorType("")}>
          Done
        </ThemeButton>
      </PanelHeader>
      {
        fetch_series && series_list.length === 0 ?
        <ActivityModalContainer>
          <img
           alt="loading"
           width="40"
           height="40"
           style={{margin: 'auto', display:'block'}}
           src={require("static/img/Theme-loader.gif")}
         />
        </ActivityModalContainer>
          :
          <ActivityModalContainer>
            <SelectionLabels primary>
              Select Series from below
            </SelectionLabels>
            <SelectTagsListContainer>
              <InfiniteScrollParentContainer position="relative" noTop>
                <InfiniteScroll
                  pageStart={0}
                  loadMore={fetchMoreSeries}
                  style={{ position: "relative" }}
                  hasMore={series_result && series_result.has_next}
                  loader={
                    <InfiniteScrollLoader className="loader" key={0}>
                      <img
                        alt="loader"
                        width="50"
                        height="50"
                        src={require("static/img/Theme-loader.gif")}
                      />
                    </InfiniteScrollLoader>
                  }
                  useWindow={false}
                >
                  {series_list && series_list.map((series, i) => (
                    <TagLabelContainer
                      key={i}
                      onClick={() => handleSeriesTag(series.id)}
                    >
                      <p style={{padding: 5}}>{`${series.name} (${series.stories.length} stories)`}</p>
                    </TagLabelContainer>
                  ))}

                </InfiniteScroll>
              </InfiniteScrollParentContainer>
            </SelectTagsListContainer>
          </ActivityModalContainer>
      }
    </SeriesEditorMainContainer>
  );
}
export default connectStore({
  story
})(SeriesEditor)
